module.exports = __webpack_public_path__ + "img/xing-shape.4c9ea66d.png";